import { DownloadButton } from "~/components/Buttons/DownloadButton";
import { createPdfGenerator } from "~/primitives/generator";
import { isAuthenticated } from "~/stores/auth";
import { useDocumentContext } from "../../../providers/context";

export function DocumentDownloadButton() {
	let button: HTMLButtonElement | undefined;

	const { selected, buildNumber, documentId } = useDocumentContext();

	const [isDownloading, download] = createPdfGenerator(
		() => "articles",
		() => selected()?.title ?? "",
	);

	const downloadArticle = () => {
		const _selected = selected();

		if (!button || !_selected) {
			return;
		}

		download(
			{
				articles: [_selected.id],
				document: documentId(),
				build: buildNumber(),
			},
			button,
		);
	};

	return (
		<DownloadButton
			ref={button}
			class={"min-w-9 min-h-9"}
			variant="outline"
			radius="xl"
			loading={isDownloading()}
			onClick={downloadArticle}
			disabled={!isAuthenticated() && selected()?.isProtected}
		/>
	);
}
